import { TableDomain } from "_components/Abstractions/TableDomain";

export function ExternalWeighingContractorTable({ items, onSelect }) {
  const keyColumn = "externalContractorId";
  const columns = [
    {
      name: "name1",
      headerName: "Nazwa 1",
    },
    {
      name: "name2",
      headerName: "Nazwa 2",
    },
    {
      name: "taxId",
      headerName: "NIP",
    },
    {
      headerName: "Adres",
      map: (item) => [item.street, item.postalCode, item.city].filter(Boolean).join(", "),
    },
  ];

  const props = {
    keyColumn,
    columns,
    items,
    onSelect,
    selectable: true,
  };

  return (
    <>
      <TableDomain {...props}></TableDomain>
    </>
  );
}
